import * as types from '../actions/types';

const initialState = {
    searchquerydata:[],
    success: false
}

export default function QuerySearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_QUERY:
            return {
               
                searchquerydata:action.payload,
                success: true
            } 
        default:
            return state
    }
}
